import React, { useState, useEffect } from 'react';
import { LogoIcon, TwitchIcon, YouTubeIcon, SunIcon, MoonIcon } from './Icons';
import { UserInfo } from '../types';
import { logout, loginWithTwitch, loginWithYouTube } from '../api';
import { loadSettings, saveSettings, applyTheme } from './Settings';

interface HeaderProps {
  userInfo: UserInfo | null;
  onLogout: () => void;
}

export const Header: React.FC<HeaderProps> = ({ userInfo, onLogout }) => {
  const [theme, setTheme] = useState<'dark' | 'light'>('dark');

  useEffect(() => {
    const settings = loadSettings();
    setTheme(settings.theme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    applyTheme(newTheme);
    const settings = loadSettings();
    saveSettings({ ...settings, theme: newTheme });
  };

  const handleLogout = async () => {
    try {
      await logout();
      onLogout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const isAuthenticated = userInfo?.authenticated;
  const hasTwitch = userInfo?.connections.twitch.connected;
  const hasYouTube = userInfo?.connections.youtube.connected;

  return (
    <header className="header">
      <div className="container header-content">
        <a href="/" className="logo">
          <LogoIcon />
          <span>Stream Tracker</span>
        </a>
        
        <div className="header-actions">
          <button
            className="btn btn-ghost btn-icon"
            onClick={toggleTheme}
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            aria-label="Toggle theme"
          >
            {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
          </button>
          
          {isAuthenticated && (
            <div className="nav-buttons">
              {!hasTwitch && (
                <button className="btn btn-twitch btn-sm" onClick={loginWithTwitch}>
                  <TwitchIcon />
                  <span className="btn-text">Connect Twitch</span>
                </button>
              )}
              {!hasYouTube && (
                <button className="btn btn-youtube btn-sm" onClick={loginWithYouTube}>
                  <YouTubeIcon />
                  <span className="btn-text">Connect YouTube</span>
                </button>
              )}
              <button className="btn btn-outline btn-sm" onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
